<template>
  <div class="result">
    <app-container>
      <h1 class="result__title">
        Ваш результат теста на профориентацию
      </h1>
      <div class="page-grid">
        <div class="page-grid__content">
          <div class="user-info">
            <span class="user-info__item"><icon-user class="user-info__icon"/>{{ userInfo.name }}</span>
            <span class="user-info__item"><icon-email class="user-info__icon"/>{{ userInfo.email }}</span>
            <span class="user-info__item"><icon-phone class="user-info__icon"/>{{ userInfo.phone }}</span>
          </div>
          <app-button
            class="result__button"
            type="button"
            @click.native="print"
          >
            Скачать .PDF
          </app-button>
          <test-result
            class="result__test-result"
            :results="results"
          />
        </div>
        <img
          class="page-grid__image"
          src="@/assets/images/result-bg.svg"
        >
      </div>
      <h1 class="result__title_second">
        Профессии и экзамены для подготовки:
      </h1>
      <div class="result__cards">
        <ul class="cards-list">
          <li
            v-for="(result, index) in resultsRange"
            :key="index"
            class="cards-list__item"
          >
            <profession-card
              :exam="result.exams"
              :percent="result.percent"
              :profession="result.professions"
            />
          </li>
        </ul>
      </div>
    </app-container>
  </div>
</template>

<script>
import AppContainer from '../components/Base/AppContainer';
import IconUser from '../components/Icons/IconUser';
import IconEmail from '../components/Icons/IconEmail';
import IconPhone from '../components/Icons/IconPhone';
import AppButton from '../components/Base/AppButton';
import TestResult from '../components/Forms/TestResult';
import ProfessionCard from '../components/Cards/ProfessionCard';

function calculatePercent(sum, count, maximum) {
  return Math.floor(((Number(sum) / (count * maximum)) * 100));
}

export default {
  name: 'Result',
  components: {
    AppContainer,
    AppButton,
    IconUser,
    IconEmail,
    IconPhone,
    TestResult,
    ProfessionCard,
  },
  data() {
    return {
      userInfo: [],
      maximumNumber: 5,
      results: [],
    };
  },
  computed: {
    /* eslint-disable object-shorthand */
    resultsRange() {
      return this.results.slice(0, 3);
    },
  },
  async created() {
    try {
      const userId = this.$route.params.id;
      const [response] = (await this.$axios.get(`/users/${userId}`)).data;
      this.userInfo = response;
    } catch (error) {
      console.log(error);
    }
    try {
      const userId = this.$route.params.id;
      const array = [];
      const { data } = await this.$axios.get(`/resume/${userId}`);
      // eslint-disable-next-line no-restricted-syntax
      for (const prop of data) {
        if (prop) {
          const {
            // eslint-disable-next-line camelcase
            sum_weight,
            count,
            exams,
            professions,
          } = prop;
          const percent = calculatePercent(sum_weight, count, this.maximumNumber);
          array.push({
            category_name: prop.category,
            percent,
            exams,
            professions,
          });
        }
      }
      this.results = array.sort((a, b) => (a.percent < b.percent ? 1 : -1));
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    window.addEventListener('beforeprint', this.onBeforePrint);
    window.addEventListener('afterprint', this.onAfterPrint);
  },
  beforeDestroy() {
    window.removeEventListener('beforeprint', this.onBeforePrint);
    window.removeEventListener('afterprint', this.onAfterPrint);
  },
  methods: {
    print() {
      window.print();
    },
    onBeforePrint() {
      document.querySelector('.app-header').style.display = 'none';
      document.querySelector('.result').style.padding = '0';
      document.querySelector('.footer').style.display = 'none';
    },
    onAfterPrint() {
      document.querySelector('.app-header').style.display = 'block';
      document.querySelector('.result').style.padding = '100px';
      document.querySelector('.footer').style.display = 'block';
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-grid {
    page-break-after: always;
  }
  .page-grid__image {
    max-width: calc(100% + 70px);
    margin-left: -70px;
    z-index: -1;
  }
  .result {
    padding: 100px 0;
    display: flex;
    &__button {
      margin: 25px 0;
      @media print {
        display: none;
      }
    }
    &__test-result {
      margin: 50px 0;
      align-content: center;
      page-break-after: always;
      @media print {
        margin-left: 100px;
      }
    }
    &__title {
      &_second {
        @media print {
          display: none;
        }
      }
    }
    &__cards {
      @media print {
        transform: rotate(90deg);
        margin: 400px 100px 0 0;
      }
    }
  }

  .user-info {
    display: flex;
    flex-direction: column;
    font-size: 19px;
    &__icon {
      width: 20px;
      height: 20px;
      margin-right: 15px;
    }
    &__item {
      padding: 5px 0;
      align-content: center;
    }
  }

  .cards-list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  @media screen and (max-width: 992px) {
    .result {
      &__test-result {
        width: auto;
      }
      &__title {
        &_second {
          text-align: center;
        }
      }
    }
    .cards-list {
      align-items: center;
      flex-direction: column;
      &__item {
        margin-bottom: 16px;
      }
    }
  }

  @media screen and (max-width: 576px) {
    .result {
      &__test-result {
        width: 288px;
      }
      &__title {
        font-size: 28px;
      }
      &__title {
        &_second {
          margin: 0;
          text-align: left;
          font-size: 28px;
        }
      }
    }
    .cards-list {
      flex-direction: column;
      &__item {
        margin-bottom: 16px;
      }
    }
  }
</style>
